<template>
  <div>
    <vx-card>
      <div class="h-12 mt-3 fit-height">
        <div class="w-full">
          <h3>Selecione o período para a extração</h3>
        </div>
        <div class="flex fit-height h-12 mt-6">
          <div class="w-1/2 fit-height mr-3">
            <datepicker placeholder="Data inicial" v-model="dataInicial" :bootstrapStyling="true" format="dd/MM/yyyy" @selected="start"></datepicker>
            <span class="text-danger text-sm" v-if="erroInicial">Data inicial é obrigatório</span>
          </div>
          <div class="w-1/2 fit-height ml-3">
            <datepicker placeholder="Data final" v-model="dataFinal" :bootstrapStyling="true" format="dd/MM/yyyy" @selected="end"></datepicker>
            <span class="text-danger text-sm" v-if="erroFinal">Data final é obrigatório</span>
          </div>
        </div>
        <vs-button type="border" size="medium" icon-pack="feather" icon="icon-download" color="success" v-on:click="extrair" class="w-full mt-6">Extrair</vs-button>
      </div>
    </vx-card>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker
  },
  data() {
    return {
      dataInicial: null,
      dataFinal: null,
      dataInicial_mili: 0,
      dataFinal_mili: 0,
      erroInicial: false,
      erroFinal: false
    }
  },
  methods: {
    start: function(e) {
      let dataInicial = new Date(e).setHours(0,0,0,0);
      this.dataInicial = new Date(dataInicial);
      this.dataInicial_mili = dataInicial;
    },
    end: function(e) {
      let dataFinal = new Date(e).setHours(23,59,59,59);
      this.dataFinal = new Date(dataFinal);
      this.dataFinal_mili = dataFinal;
    },
    extrair: function() {
      let canExtract = true;
      if (this.dataInicial_mili == 0) {
        this.erroInicial = true;
        canExtract = false;
      } else {
        this.erroInicial = false;
      }

      if (this.dataFinal_mili == 0) {
        this.erroFinal = true;
        canExtract = false;
      } else {
        this.erroFinal = false;
      }

      if (canExtract) {
        window.open(this.$API_URL + "/extracao/" + this.dataInicial_mili + "/" + this.dataFinal_mili, '_blank');
      }
    },
  }
}
</script>

<style scoped>
  .fit-height {
    height: fit-content !important;
  }
</style>
